import React, { Component } from 'react'
import { StatusAlertService } from 'react-status-alert'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import TaskDetailTopUI from './TaskDetailTopUI.js'

class TaskDetailTopTopSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      editStatus: false,
      editPriority: false,
      editDueDate: false,
      editAssignee: false,
      editTaskUsers: false,
      editTaskNotes: false,
      //
      taskUserList: null,
      taskUserIdList: null,
    }
    this.taskId = this.props.task.taskId // used to avoid multiple fetches in componentWillReceiveProps
    this.bottomDivRef = null
  }

  render() {
    return (
      <TaskDetailTopUI
        context={this.props.context}
        messageList={this.state.messageList}
        project={this.props.project}
        task={this.props.task}
        taskUserList={this.state.taskUserList}
        taskUserIdList={this.state.taskUserIdList}
        // top
        editStatus={this.state.editStatus}
        editPriority={this.state.editPriority}
        editDueDate={this.state.editDueDate}
        editAssignee={this.state.editAssignee}
        editTaskUsers={this.state.editTaskUsers}
        editTaskNotes={this.state.editTaskNotes}
        onEditStatusClick={() => {this.setState({editStatus: true})}}
        onEditDueDateClick={() => {this.setState({editDueDate: true})}}
        onEditPriorityClick={() => {this.setState({editPriority: true})}}
        onEditAssigneeClick={() => {this.setState({editAssignee: true})}}
        onEditTaskUsersClick={() => {this.setState({editTaskUsers: true})}}
        onEditTaskNotesClick={() => {this.setState({editTaskNotes: true})}}
        onStatusChange={this.onStatusChange}
        onDueDateChange={this.onDueDateChange}
        onPriorityChange={this.onPriorityChange}
        onAssigneeChange={this.onAssigneeChange}
        onTaskUsersChange={this.onTaskUsersChange}
        onTaskUsersSubmit={this.onTaskUsersSubmit}
        onTaskNotesChange={this.onTaskNotesChange}
        statusList={this.props.statusList}
        priorityList={this.props.priorityList}
        projectUserMap={this.props.projectUserMap}
        projectUserList={this.props.projectUserList}
        onDropDownClickOutside={this.onDropDownClickOutside}
        onDatePickerClickOutside={this.onDatePickerClickOutside}
        onTaskNotesCancel={this.onTaskNotesCancel}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    this.getTaskUsers(context, this.props.task.taskId)
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.task && props.task.taskId !== this.taskId) {
      this.taskId = props.task.taskId
      this.getTaskUsers(props.context, props.task.taskId)
    }
  }

  onDropDownClickOutside = () => {
    this.setState({editStatus: false, editPriority: false, editAssignee: false})
  }

  onDatePickerClickOutside = () => {
    console.log('onDatePickerClickOutside')
    // if component is hidden after clearing date, then onChange event is not thrown
    // hence delay hidding
    setTimeout(() => {
      this.setState({editDueDate: false})
    }, 200)
  }

  onTaskNotesCancel = () => {
    this.setState({editTaskNotes: false})
  }

  onStatusChange = (status) => {
    RestApiUtils.put(this.props.context,
      `/api/tasks/${this.props.task.taskId}/status`,
      this.onStatusChangeCallback, {status: status}
    )
  }

  onStatusChangeCallback = response => {
    this.setState({editStatus: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    this.props.onTaskListUpdated(response.updatedTaskList)

    // task log is null if updated status was same as status in backend
    let taskLogList = response.updatedTaskList.filter(task => task.taskLog !== null).map(task => task.taskLog)
    var event = new CustomEvent('taskLogList', { detail: taskLogList })
    document.body.dispatchEvent(event)
  }

  handleError(errorList) {
    errorList.forEach(error => {
      if (error.errorCode === 'NotFound') {
        switch (error.objectCode) {
          case 'Task':
            this.props.onForceTaskListRefresh(this.props.task.projectId)
            break;
          case 'ProjectUser':
            this.props.onForceProjectUserListRefresh(this.props.task.projectId)
            break;
          default:
        }
      }
    })
    StatusAlertService.showError(errorList[0].message, {withCloseIcon: false})
  }

  onPriorityChange = (priority) => {
    RestApiUtils.put(this.props.context,
      `/api/tasks/${this.props.task.taskId}/priority`,
      this.onPriorityChangeCallback, {priority: priority}
    )
  }

  onPriorityChangeCallback = response => {
    this.setState({editPriority: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    this.props.onTaskListUpdated(response.updatedTaskList)

    let taskLogList = response.updatedTaskList.filter(task => task.taskLog !== null).map(task => task.taskLog)
    var event = new CustomEvent('taskLogList', { detail: taskLogList })
    document.body.dispatchEvent(event)
  }

  onDueDateChange = (selectedDateISO) => {
    console.log(selectedDateISO);
    RestApiUtils.put(this.props.context,
      `/api/tasks/${this.props.task.taskId}/due-date`,
      this.onDueDateChangeCallback, {dueDate: selectedDateISO}
    )
  }

  onDueDateChangeCallback = response => {
    this.setState({editDueDate: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    this.props.onTaskListUpdated(response.updatedTaskList)

    let taskLogList = response.updatedTaskList.filter(task => task.taskLog !== null).map(task => task.taskLog)
    var event = new CustomEvent('taskLogList', { detail: taskLogList })
    document.body.dispatchEvent(event)
  }

  onAssigneeChange = (assignee) => {
    RestApiUtils.put(this.props.context,
      `/api/tasks/${this.props.task.taskId}/assignee`,
      this.onAssigneeChangeCallback, {assignedUserId: assignee}
    )
  }

  onAssigneeChangeCallback = response => {
    this.setState({editAssignee: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    this.props.onTaskListUpdated(response.updatedTaskList)

    // when assignee added or changed, new assigneed added as task user (watcher)
    let updatedTask = response.updatedTaskList.filter(task => task.userId)
    if (updatedTask) {
      CacheManager.removeObject(CacheKeys.TaskUsers(this.props.task.taskId))
      this.getTaskUsers(this.props.context, this.props.task.taskId)
    }

    let taskLogList = response.updatedTaskList.filter(task => task.taskLog !== null).map(task => task.taskLog)
    var event = new CustomEvent('taskLogList', { detail: taskLogList })
    document.body.dispatchEvent(event)
  }

  onTaskUsersChange = (taskUserIdList) => {
    this.setState({taskUserIdList: taskUserIdList})
  }

  onTaskUsersSubmit = () => {
    // check if anything changed
    if (this.state.taskUserIdList.every(userId => this.state.taskUserList.map(taskUser => taskUser.userId).includes(userId)) &&
      this.state.taskUserList.every(taskUser => this.state.taskUserIdList.includes(taskUser.userId))) {
        this.setState({editTaskUsers: false})
        return
    }

    RestApiUtils.put(this.props.context,
      `/api/tasks/${this.props.task.taskId}/users`,
      this.onTaskUsersSubmitCallback, {userIds: this.state.taskUserIdList}
    )
  }

  onTaskUsersSubmitCallback = response => {
    this.setState({editTaskUsers: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    this.setState({taskUserList: response.taskUserList})
    CacheManager.removeObject(CacheKeys.TaskUsers(this.props.task.taskId))
  }

  onTaskNotesChange = (notes) => {
    console.log(notes);
    RestApiUtils.put(this.props.context,
      `/api/tasks/${this.props.task.taskId}/notes`,
      this.onTaskNotesChangeCallback, {taskNotes: notes}
    )
  }

  onTaskNotesChangeCallback = response => {
    this.setState({editTaskNotes: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    this.props.onTaskListUpdated([response.task])
  }

  getTaskUsers(context, taskId) {
    let cacheManager = new CacheManager({
      resource: `/api/tasks/${taskId}/users`,
      cacheKey: CacheKeys.TaskUsers(taskId),
      callback: this.getTaskUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskUsersCallback = (response) => {
    if (response.errorList.length > 0) {
      // error can happen when UI is out of sync with backend
      return
    }
    this.setState({
      taskUserList: response.taskUserList,
      taskUserIdList: response.taskUserList.map(user => user.userId)
    })
  }

  getMessages(context) {
    let arr = [
      'c_status',
      'c_priority',
      'c_due_date',
      'c_assignee',
      'c_watchers',
      'c_select',
      'c_notes',
      'c_none',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('c_tsk_dtl_top', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default TaskDetailTopTopSF
